import * as yup from 'yup'

export const socialMediaRegexErrorMessage =
  'Only letters, numbers, underscores and dots are allowed. Spaces are not allowed.'

export const attributeShape = {
  type: yup.string().required(),
  category: yup.string().required(),
  value: yup.mixed().nullable(),
}

export const supportValidationSchema = yup.object().shape({
  email: yup
    .string()
    .email('Must be a valid email address')
    .required('Please provide an email address where we can reach you'),
  topic: yup
    .object()
    .shape({
      value: yup.number().required(),
      label: yup.string().required(),
    })
    .nullable()
    .required('Please select a topic'),
  question: yup
    .string()
    .max(500, 'Question should be at max 500 chars long.')
    .when('topic', {
      is: (topic: { value: string; label: string }) =>
        topic && topic.label === 'Other',
      then: (schema) => schema.required('Please describe your question'),
      otherwise: (schema) => schema.notRequired(),
    }),
  attachmentUrl: yup.string().optional(),
})

export type SupportPayload = yup.InferType<typeof supportValidationSchema>

export interface SupportFormValues extends Omit<SupportPayload, 'topic'> {
  topic: { value: number; label: string } | null
}
